/**
 * @overview minimally-styled "text-only" button
 */

import React from 'react'
import { Button } from 'evergreen-ui'

class TextButton extends React.PureComponent {
  render() {
    return (
      <Button
        appearance="minimal"
        borderRadius={2}
        height="auto"
        lineHeight="unset"
        padding="0"
        fontSize="inherit"
        {...this.props}
      />
    )
  }
}

export default TextButton
